module.exports = __webpack_public_path__ + "img/ua.0ba53a8b.svg";